// src/AirplaneTakeOffAirstrip.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirplaneTakeOffAirstrip_default = createIcon({
  displayName: "AirplaneTakeOffAirstrip",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M7.38375 4.00049C7.29447 4.00324 7.20392 4.01696 7.11617 4.04346C6.48017 4.23646 6.18852 4.97136 6.51852 5.54736L9.87203 11.397L4.77828 12.7407L3.29391 11.4927C3.09091 11.3217 2.81549 11.2653 2.56149 11.3423C2.07349 11.4883 1.85036 12.0546 2.10836 12.4946L3.39742 14.6938C3.85142 15.4678 4.7638 15.8457 5.6318 15.6177L20.3564 11.7388C20.3584 11.7381 20.3603 11.7375 20.3623 11.7368C21.0792 11.6108 21.6021 10.9882 21.6025 10.2603C21.6025 9.43183 20.9309 8.76026 20.1025 8.76026C19.9719 8.76028 19.8419 8.77735 19.7158 8.81104V8.80908L14.4853 10.186L8.11813 4.27588C7.91638 4.08838 7.6516 3.99224 7.38375 4.00049ZM3.20406 18.7603C2.65206 18.7603 2.20406 19.2083 2.20406 19.7603C2.20406 20.3123 2.65206 20.7603 3.20406 20.7603H19.2041C19.7561 20.7603 20.2041 20.3123 20.2041 19.7603C20.2041 19.2083 19.7561 18.7603 19.2041 18.7603H3.20406Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  AirplaneTakeOffAirstrip_default
};
